module.exports = __webpack_public_path__ + "img/banker.9cb6575f.svg";